import { render, staticRenderFns } from "./BaseChangelogModal.vue?vue&type=template&id=9857b4ce&"
import script from "./BaseChangelogModal.vue?vue&type=script&lang=js&"
export * from "./BaseChangelogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports